export default "__VITE_ASSET__2863e134__"